import * as R from 'ramda'
import createSelector from 'utils/redux/createSelector'
import { createSearchAction, getSearchSelectors } from 'redux-search'
import { projectsEx } from './projects'
import { propertiesEx } from './properties'
import { tasksEx } from './tasks'
import { transactionsEx } from './transactionsTable'
import { leasesEx } from './leases'
import { tenantsEx } from './tenant'
import { tenants } from './entities'
import { sort, currentSort, db } from './common'

export let allEx = createSelector(
	[propertiesEx, tenantsEx],
	(propertiesEx, tenantsEx) =>{
		return {...propertiesEx, ...tenantsEx}
	}
)

let resourceIndexes = ['propertyAlias', 'managerName', 'title'
	,'alias', 'address', 'owner', 'taskContent', 'property', 'project', 'manager', 'taskType', 'party'
	, 'description', 'amountString', 'paymentMethod', 'dueDateString', 'tenant', 'rentString', 'dateFromString', 'dateTillString', 'phoneNumber', 'email']

let {
	text
  , result
  , unfilteredResult
} = getSearchSelectors({
	resourceName: 'all'
  ,	resourceSelector: (resourceName, state) => allEx(state)
})

let typeToRoute = {
    'bill': 'transaction',
    'invoice': 'transaction',
    'invoice-payment': 'transaction',
    'merchant': 'vendor',
    'term': 'term',
    'listing': 'listing',
    'project': 'project',
    'property': 'property',
    'lease': 'lease',
    'tenant': 'tenant',
	'task': 'task',
    'owner': 'owner',
}

let sortOptions = (currentSort) => ({
	secondary: currentSort.sortBy == 'type' ? 'searched' : 'type'
  , secondaryDirection: currentSort.sortBy == 'type' ? 'ASC' : 'DESC'
})

export let allTable = createSelector(
	[allEx, text, result, unfilteredResult, tenants, sort('all', sortOptions)],
	(allEx, text, result, unfilteredResult, tenants, sort) => {
		let exFun = o => {
			let searched='';
			if (o.type == 'billfalse' || o.type == 'billtrue'){
				o.type = 'bill'
			}
			if (o.type == 'invoicefalse' || o.type == 'invoicetrue'){
				o.type = 'invoice'
			}
			if (o.type == 'transaction/invoice-payment'){
				o.type = 'invoice-payment'
			}
			let link = typeToRoute[o.type] + '/' + o._id;
			resourceIndexes.map(x=>{
				if (o[x]){
					if (o.type=='project' && x == 'tenant' && o[x]){
						searched += tenants[o[x]] && ((tenants[o[x]].firstname && tenants[o[x]].firstname+' '+tenants[o[x]].lastname) || tenants[o[x]].tenant) + ', '
					} else{
						searched += o[x] + ', '
					}
				}

			})
			return {...o, searched, link}
		}
		text
		if(!text) return {}

		allEx = R.filter(x=>x)(R.map(id => allEx[id], unfilteredResult))

		return R.pipe(R.map(exFun), R.groupBy(R.prop('type')))(allEx)
 	}
 )



// WEBPACK FOOTER //
// ./src/selectors/globalSearch.js